/*
 由于项目已有主题设置组件及相关配置，
 为避免混淆，不采用 theme 来命名，改为配色方案 colorScheme
 */
import { ElMessage } from 'element-plus';
import { getLocalStorage, setLocalStorage } from '@/utils/storage';
const storeKey = 'color-scheme';
// 配色方案列表，新增配色方案后，需要在此处注册方案信息
export const schemes = [{
  // 配色方案id，建议与文件名一致
  id: 'default',
  // 外显命名
  name: '博智林主题'
}, {
  // 配色方案id，建议与文件名一致
  id: 'light',
  // 外显命名
  name: '数管中心主题'
}];
/*
 注册配色方案主题，目前不需要用到
 */
// function registerColorScheme() {}
/*
 从本地存储获取主题id
 */
export function getSchemeId() {
  return getLocalStorage(storeKey) || 'default';
}
/*
 将主题id存储到本地存储
 */
function setSchemeId(id) {
  setLocalStorage(storeKey, id);
}
function handleConfig(config) {
  for (const [k, v] of Object.entries(config)) {
    for (const [prop, value] of Object.entries(v)) {
      if (value) {
        document.documentElement.style.setProperty(`--${k}-${prop}`, `${value}`);
      } else {
        document.documentElement.style.removeProperty(`--${k}-${prop}`);
      }
    }
  }
}
/*
 切换主题
 */
export function switchColorScheme(id) {
  // 打包不包含index文件
  // 打包到单独文件
  // 以下块注释内容用于webpack打包配置，不可删除
  import(/* webpackExclude: /^index/ */
  /* webpackMode: "lazy" */
  `./${id}`).then(({
    default: config
  }) => {
    if (!config) {
      ElMessage({
        message: '当前主题不存在',
        type: 'error'
      });
      return;
    }
    handleConfig(config);
    // 配置获取成功后才将主题id存储
    setSchemeId(id);
  }).catch(error => {
    console.log(error);
    ElMessage({
      message: '主题设置失败',
      type: 'error'
    });
  });
}
/*
 初始化设置主题，默认值为 default 主题
 */
export function initColorScheme() {
  const id = getSchemeId();
  switchColorScheme(id);
}